// extracted by mini-css-extract-plugin
export default {"selector-button":"SelectorButton_selector-button__oTC7X","selected":"SelectorButton_selected__U6Rte"};